import React from 'react';
import { Helmet } from 'react-helmet-async';
interface OrganizationSchemaProps {
  name: string;
  url: string;
  logo: string;
  description: string;
  sameAs?: string[];
}
export function OrganizationSchema({
  name,
  url,
  logo,
  description,
  sameAs = []
}: OrganizationSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name,
    url,
    logo,
    description,
    sameAs
  };
  return <Helmet data-id="element-1040">
      <script type="application/ld+json" data-id="element-1041">{JSON.stringify(schema)}</script>
    </Helmet>;
}
interface ServiceSchemaProps {
  name: string;
  description: string;
  provider: string;
  areaServed: string;
  serviceType: string;
}
export function ServiceSchema({
  name,
  description,
  provider,
  areaServed,
  serviceType
}: ServiceSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    description,
    provider: {
      '@type': 'Organization',
      name: provider
    },
    areaServed: {
      '@type': 'Country',
      name: areaServed
    },
    serviceType
  };
  return <Helmet data-id="element-1042">
      <script type="application/ld+json" data-id="element-1043">{JSON.stringify(schema)}</script>
    </Helmet>;
}
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQSchemaProps {
  faqs: FAQItem[];
}
export function FAQSchema({
  faqs
}: FAQSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }))
  };
  return <Helmet data-id="element-1044">
      <script type="application/ld+json" data-id="element-1045">{JSON.stringify(schema)}</script>
    </Helmet>;
}
interface VideoSchemaProps {
  name: string;
  description: string;
  thumbnailUrl: string;
  uploadDate: string;
  contentUrl: string;
  embedUrl: string;
  duration?: string;
}
export function VideoSchema({
  name,
  description,
  thumbnailUrl,
  uploadDate,
  contentUrl,
  embedUrl,
  duration
}: VideoSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name,
    description,
    thumbnailUrl,
    uploadDate,
    contentUrl,
    embedUrl,
    ...(duration && {
      duration
    })
  };
  return <Helmet data-id="element-1046">
      <script type="application/ld+json" data-id="element-1047">{JSON.stringify(schema)}</script>
    </Helmet>;
}
interface BreadcrumbItem {
  name: string;
  url: string;
}
interface BreadcrumbSchemaProps {
  items: BreadcrumbItem[];
}
export function BreadcrumbSchema({
  items
}: BreadcrumbSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `https://theHIREadvantage.co${item.url}`
    }))
  };
  return <Helmet data-id="element-1048">
      <script type="application/ld+json" data-id="element-1049">{JSON.stringify(schema)}</script>
    </Helmet>;
}
export function WebsiteSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'The HIRE Advantage',
    url: 'https://theHIREadvantage.co',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://theHIREadvantage.co/search?q={search_term_string}',
      'query-input': 'required name=search_term_string'
    }
  };
  return <Helmet data-id="element-1050">
      <script type="application/ld+json" data-id="element-1051">{JSON.stringify(schema)}</script>
    </Helmet>;
}